import React from 'react';
import PersonalPropertyCard from '../PersonalProperty';

interface PropertyItemsProps {
  property: any;
  index: number;
  selectedProperties: (string | number)[];
  showCheckbox?: boolean;
  onSelect: any;
  refetchPropertyData: any;
  overseas?: boolean;
}

const PropertyItems: React.FC<PropertyItemsProps> = ({
  property,
  index,
  selectedProperties,
  showCheckbox = true,
  onSelect,
  refetchPropertyData,
  overseas,
}) => {
  return (
    <div
      key={index}
      style={{
        width: '100%',
        marginBottom: '1rem',
      }}
    >
      <PersonalPropertyCard
        property={property}
        showCheckbox={showCheckbox}
        isSelected={selectedProperties.includes(property.id)}
        onSelect={() => onSelect(property.id)}
        refetchPropertyData={refetchPropertyData}
        overseas={overseas}
      />
    </div>
  );
};

export default PropertyItems;
